import _ from 'lodash'
import { CLEAR_FILE_SUCCESS, SET_FILE_SUCCESS, SET_FILES_SUCCESS, } from '../actions/file'

const file = (state = {}, action) => {
  switch (action.type) {
    case SET_FILE_SUCCESS:
      return {
        ...state,
        [action.data.key]: action.data.file
      }
    case SET_FILES_SUCCESS:
      return {
        ...state,
        [action.data.key]: state[action.data.key] ?
          [...state[action.data.key], ...action.data.files] : [...action.data.files]
      }
    case CLEAR_FILE_SUCCESS:
      return _.omit(state, action.data.key)
    default:
      return state
  }
}

export default file


// WEBPACK FOOTER //
// ./src/reducers/file.js